import React from 'react';

function Textarea({
  id,
  name,
  value,
  onChange,
  required,
  placeholder,
  label,
  error,
  readOnly,
  className,
  rows,
}) {
  return (
    <div className={`${className} text-sm tracking-tight space-y-1`}>
      {label && (
        <div className="font-semibold">
          {label} {required && <span className="text-red-500">*</span>}
        </div>
      )}
      <textarea
        id={id}
        name={name}
        rows={rows}
        readOnly={readOnly}
        placeholder={placeholder}
        required={required}
        value={value}
        onChange={onChange}
        className="placeholder-gray-300 text-gray-900 text-sm rounded-md p-3 w-full appearance-none focus:ring-1 focus:ring-accent border border-gray-200 focus:border-accent outline-none focus:outline-none transition ease-in-out duration-500"
      />
      {error && <div className="text-sm font-light text-red-500">{error}</div>}
    </div>
  );
}

export default Textarea;
